export default "__VITE_ASSET__VRtELnxL__"